export default {
  key: 'skogarhverfi',
  basepath: '/lodir/skogarhverfi',
  image: {
    src: require('images/lodir/skogarhverfi/cam05.jpg'),
    width: 4000,
    height: 2250,
  },
  afangar: [
    require('./afangi-3a.js').default,
    require('./afangi-3c.js').default,
    require('./afangi-5.js').default,
  ],
}
